import { gql } from "@apollo/client";

export const AtsStckItemLdgrNode = gql`
  query AtsStckItemLdgrNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsStckItemLdgr {
        id
        stkOb
        stkObRate
        item {
          code
          desc
          uom
          hsnCode
          igst
          sgst
          cgst
          categoryDetails {
            categoryName
          }
          manufacturerDetails {
            manufacturer
          }
        }
        ticketDetails {
          remarks
          status
          ticket {
            ticketDate
          }
        }
      }
    }
  }
`;

export const ExportItemDetails = gql`
  query ExportItemDetails(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $siteID: ID!
    $junctionID: ID!
    $ldgrID: Int!
    $itemsList: [String!]!
    $empID: Int!
  ) {
    ExportItemDetails(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      junctionID: $junctionID
      ldgrID: $ldgrID
      itemsList: $itemsList
      empID: $empID
    )
  }
`;
